import { render, staticRenderFns } from "./AddQualification.vue?vue&type=template&id=4c058088"
import script from "./AddQualification.vue?vue&type=script&lang=js"
export * from "./AddQualification.vue?vue&type=script&lang=js"
import style0 from "./AddQualification.vue?vue&type=style&index=0&id=4c058088&prod&lang=css"
import style1 from "./AddQualification.vue?vue&type=style&index=1&id=4c058088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports